




















































































































































































































































































import { Component, Mixins, Prop, Emit, Watch } from 'vue-property-decorator';
import { State, Mutation, Action } from 'vuex-class';
import { TextOutput, ExternalWallet, AuthQuery } from '~/mixins';
import TransactionFeeSelector from '~/components/Wallet/TransactionFeeSelector.vue';
import RequirePasscode from '~/components/Wallet/RequirePasscode.vue';
import InsufficientFunds from '~/components/Wallet/InsufficientFunds.vue';
import GiveAllowance from '~/components/Wallet/GiveAllowance.vue';
import FullScreenDialog from '~/components/FullScreenDialog.vue';
import { IWallet } from '~/store/inventory/types';
import { ICurrentPage } from '~/store/types';
import transactionFeeEstimateQuery from '~/queries/wallets/transactionFeeEstimate.gql';
import LegalAgreements from '~/components/LegalAgreements/LegalAgreements.vue';
import { checkForSufficientErc20Allowance } from '~/utils';
import { FiatProvider } from '../../types/fiat-provider';
import {
  IGameItemForSaleByGala,
  IGameItemProductPrice,
} from '../../store/games/types';
import Stripe from '../../mixins/Stripe';
import { StripeElements } from '@stripe/stripe-js';
import { IUser } from '../../store/profile/types';

@Component({
  components: {
    LegalAgreements,
    TransactionFeeSelector,
    RequirePasscode,
    InsufficientFunds,
    FullScreenDialog,
    GiveAllowance,
  },
})
export default class Confirm extends Mixins(
  TextOutput,
  ExternalWallet,
  Stripe,
  AuthQuery,
) {
  @State(profile => profile.user.hasGyriPassphrase, { namespace: 'profile' })
  hasGyriPassphrase!: boolean;

  @Prop(String) readonly imageUrl!: string;
  @Prop(Object) readonly product!: IGameItemForSaleByGala;
  @Prop(Number) readonly quantity!: number;
  @Prop(String) readonly purchaseCurrency!: string;
  @Prop(String) readonly transactionType!: string;
  @Prop(Number) readonly subtotal!: number;
  @Prop(String) readonly selectedCredit!: FiatProvider;
  @Prop({ type: Boolean, default: true }) readonly displayQuantity!: boolean;
  @Prop(Function) readonly buy!: (
    passcode: string,
    transactionFee: number,
  ) => Promise<{ success: boolean; results?: any; message?: string }>;
  @Prop(Function) readonly orderWithW3w!: (transactionFee: number) => void;
  @Prop(Function) readonly orderWithStripe!: (
    stripeElement: StripeElements,
  ) => void;
  @Prop(String) readonly customPurchaseLoadingVideoUrl?: string;
  @Prop(Function) readonly backToItem!: Function;
  @Prop(Number) selectedPriceRebateInUsd!: number;
  @Prop(String) galaTagName!: string;
  @Prop(Boolean) isGalaTagToken!: boolean;
  @State(profile => profile.user, { namespace: 'profile' })
  user!: IUser;

  @Action('getNewNotifications', { namespace: 'notifications' })
  getNewNotifications!: () => void;

  @Mutation updateCurrentPage!: (payload: ICurrentPage) => void;
  @Mutation toggleErrorSnackbar!: (payload?: boolean) => void;
  @Mutation updateSnackbarErrorText!: (args: any) => void;

  @Action('promptToRegister')
  private promptToRegister!: (options?: {
    redirectAfterLoginPath?: string;
  }) => void;

  agreements: boolean = false;
  orderInFlight = false;
  passcodePrompt = false;
  insufficientBalanceDialog = false;
  showAllowancePrompt = false;
  insufficientFundsWallets: IWallet[] | [] = [];

  transactionFeeCurrency =
    this.purchaseCurrency.includes('[GC]') ||
    this.isCreditCard ||
    this.purchaseCurrency.includes('[GYRI]')
      ? ''
      : 'ETH';
  transactionFeeMin = 0;
  transactionFeeMax = 0;
  transactionFeeDefault = 0;
  selectedFee = 0;
  transactionFeeUnits = 0;
  transactionFeeDecimals = 0;
  isFetchingEstimatedFee = false;
  gcTempTransferCode = 'galachain';
  tempTransferCodeHeading = 'Please enter the temporary transfer code ';
  paymentCurrencyWallet = null;
  w3wConnectionEnabled = process.env.w3wConnectionEnabled;
  orderPaymentContractAddress = process.env.orderPaymentContractAddress;
  stripeElement: StripeElements | null = null;

  get isCreditCard() {
    return this.purchaseCurrency.startsWith('CC') && this.selectedCredit;
  }

  created() {
    this.getTransactionFeeEstimate();
  }

  async mounted() {
    if (this.selectedCredit === FiatProvider.STRIPE) {
      this.createStripeElement();
    }
  }

  report() {
    console.log(
      this.selectedCredit,
      this.purchaseCurrency,
      this.transactionFeeCurrency,
    );
  }

  getTransactionFeeCurrency() {
    const previousTransactionFeeCurrency = this.transactionFeeCurrency;
    this.transactionFeeCurrency =
      this.isGalachain || this.isCreditCard ? '' : 'ETH';

    if (this.transactionFeeCurrency !== previousTransactionFeeCurrency) {
      this.getTransactionFeeEstimate();
    }

    return this.transactionFeeCurrency;
  }

  toggleAgreement(payload: any) {
    this.agreements = payload.allAccepted;
  }

  get requiresGyriPasscode() {
    return this.isGalachain;
  }

  get isMissingGyriPassphrase() {
    if (this.requiresGyriPasscode && !this.hasGyriPassphrase) {
      return true;
    }
    return false;
  }

  get missingWallet() {
    if (this.isMissingGyriPassphrase) {
      return 'gyri';
    } else if (
      !this.requiresGyriPasscode &&
      !this.walletExists &&
      !this.w3wConnectionActive
    ) {
      return 'eth';
    }
    return '';
  }

  get isGalachain() {
    const wallet = this.userWallets.find(
      w => w.symbol.toLowerCase() === this.purchaseCurrency.toLowerCase(),
    );

    if (wallet) {
      return (
        wallet.network.toLowerCase() === 'gyri' ||
        wallet.network.toLowerCase() === 'galachain'
      );
    }

    return (
      this.purchaseCurrency.includes('[GC]') ||
      this.purchaseCurrency.includes('[GYRI]')
    );
  }

  get transactionFee() {
    const total = this.selectedFee / 10 ** this.transactionFeeDecimals;

    return total * this.transactionFeeUnits;
  }

  get total() {
    if (this.purchaseCurrency === this.transactionFeeCurrency) {
      return this.subtotal + this.transactionFee;
    }

    return this.subtotal;
  }

  // formats payment currency with [GYRI] or [ETH] when needed to match wallet.symbol
  get formattedPurchaseCurrency() {
    // GalaChain currencies are always appended with [GYRI]
    if (this.isGalachain) {
      return this.purchaseCurrency;
    }

    // Check if wallets require [ETH] appended or not
    const matchingWallets = this.userWallets.filter(w =>
      w.symbol.toLowerCase().includes(this.purchaseCurrency.toLowerCase()),
    );
    const includesWalletsAppendedWithETH = matchingWallets.some(w =>
      w.symbol.endsWith('[ETH]'),
    );

    return includesWalletsAppendedWithETH
      ? `${this.purchaseCurrency}[ETH]`
      : this.purchaseCurrency;
  }

  get coinIcons() {
    const coins: { baseCurrency: string; feeCurrency?: string } = {
      baseCurrency: require(`@/assets/logos/${this.purchaseCurrency.replace(
        /\[ETH\]|\[GC\]|-(.*)/g,
        '',
      )}-icon.png`),
    };

    if (
      this.transactionFeeCurrency &&
      this.purchaseCurrency !== this.transactionFeeCurrency
    ) {
      coins.feeCurrency = require(`@/assets/logos/${this.transactionFeeCurrency.replace(
        /\[ETH\]|\[GC\]/g,
        '',
      )}-icon.png`);
    }

    return coins;
  }

  updateFee(fee: number) {
    this.selectedFee = fee;
  }

  get neededWallets() {
    return this.userWallets
      ? this.userWallets.reduce((accumulator: any[], wallet: any) => {
          if (
            wallet.symbol === this.formattedPurchaseCurrency ||
            wallet.symbol === this.transactionFeeCurrency
          ) {
            const lesserBalance = Math.min(
              +wallet.balance.confirmed,
              +wallet.balance.unconfirmed,
            );

            const sufficient =
              wallet.symbol === this.formattedPurchaseCurrency
                ? lesserBalance >= this.total
                : lesserBalance >= this.transactionFee;

            accumulator.push({
              ...wallet,
              availableBalance: lesserBalance,
              sufficient,
            });
          }
          return accumulator;
        }, [])
      : [];
  }

  get transactionFeeEstimateSymbol() {
    if (this.w3wConnectionEnabled) {
      if (this.transactionType === 'burn') {
        return 'ORDER_PAYMENT_BURN_ERC20';
      } else if (this.purchaseCurrency === 'ETH') {
        return 'ORDER_PAYMENT_TRANSFER_ETH';
      } else if (this.formattedPurchaseCurrency.includes('[ETH]')) {
        return 'ORDER_PAYMENT_TRANSFER_ERC20';
      }

      return this.purchaseCurrency;
    }
    return this.purchaseCurrency;
  }

  async getTransactionFeeEstimate() {
    if (this.transactionFeeCurrency) {
      this.isFetchingEstimatedFee = true;

      const { data } = await this.$apolloProvider.clients.gateway.query<{
        transactionFeeEstimate: {
          gasUnitsEstimate: number;
          gasPriceEstimate: {
            high: string;
            suggested: string;
            low: string;
          };
        };
      }>({
        query: transactionFeeEstimateQuery,
        variables: { symbol: this.transactionFeeEstimateSymbol },
        fetchPolicy: 'network-only',
      });

      this.transactionFeeMin = +data.transactionFeeEstimate.gasPriceEstimate
        .low;
      this.transactionFeeMax = +data.transactionFeeEstimate.gasPriceEstimate
        .high;
      this.transactionFeeDefault = +data.transactionFeeEstimate.gasPriceEstimate
        .suggested;
      this.selectedFee = this.transactionFeeDefault;
      this.transactionFeeUnits = data.transactionFeeEstimate.gasUnitsEstimate;
      this.transactionFeeDecimals = 18;
      this.isFetchingEstimatedFee = false;
    } else {
      this.transactionFeeMin = 0;
      this.transactionFeeMax = 0;
      this.transactionFeeDefault = 0;
      this.selectedFee = 0;
      this.transactionFeeUnits = 0;
      this.transactionFeeDecimals = 0;
      this.isFetchingEstimatedFee = false;
    }
  }

  checkForSufficientFunds() {
    if (this.neededWallets.length) {
      const insufficientFundsWallets = this.neededWallets.filter(
        wallet => !wallet.sufficient,
      );
      if (insufficientFundsWallets.length) {
        this.insufficientFundsWallets = insufficientFundsWallets;
        this.insufficientBalanceDialog = true;

        return false;
      }
      return true;
    }
    return false;
  }

  async placeOrder() {
    if (this.selectedCredit === FiatProvider.STRIPE && this.stripeElement) {
      this.orderInFlight = true;
      await this.orderWithStripe(this.stripeElement);
      this.orderInFlight = false;
    } else {
      return this.promptForWalletPassword();
    }
  }

  async promptForWalletPassword() {
    if (this.selectedCredit) {
      return;
    }
    if (!this.isGalachain) {
      const success = await this.establishWalletConnection();
      if (!success) return;
    }
    if (!this.user.loggedIn) {
      this.promptToRegister({ redirectAfterLoginPath: this.$route.fullPath });
      return;
    } else if (this.missingWallet) {
      this.toggleCreateWalletPrompt({
        show: true,
        walletType: this.missingWallet,
      });
      return;
    }
    const sufficientFunds = this.checkForSufficientFunds();
    if (sufficientFunds) {
      if (this.walletConnected && !this.requiresGyriPasscode) {
        const enabled = this.checkW3wConnectionEnabled();
        if (!enabled || this.orderInFlight) {
          return;
        }

        if (!this.w3wConnectionActive) {
          this.toggleCreateWalletPrompt({ show: true, walletType: 'eth' });
          return;
        }
        if (
          this.purchaseCurrency.toLowerCase() !== 'eth' &&
          process.env.orderPaymentContractAddress
        ) {
          const paymentWallet = this.neededWallets.find(
            wallet => wallet.symbol === this.formattedPurchaseCurrency,
          );
          const sufficientAllowance = await checkForSufficientErc20Allowance({
            owner: this.externalWalletAddress,
            spender: process.env.orderPaymentContractAddress,
            contractAddress: paymentWallet.contractAddress,
            neededAmount: this.subtotal,
            web3Provider: this.web3Provider,
          });
          if (!sufficientAllowance) {
            this.paymentCurrencyWallet = paymentWallet;
            this.showAllowancePrompt = true;
            return;
          }
        }
        this.orderInFlight = true;
        await this.orderWithW3w(this.selectedFee);
        this.orderInFlight = false;
      } else {
        this.passcodePrompt = true;
      }
    }
  }

  async handleSuccessfulAllowance() {
    this.orderInFlight = true;
    this.showAllowancePrompt = false;
    await this.orderWithW3w(this.selectedFee);
    this.orderInFlight = false;
  }

  handleBuy(passcode: string) {
    return this.buy(passcode, this.selectedFee);
  }

  matchInstructions(input: string) {
    return (
      input === this.gcTempTransferCode ||
      `Input must match "${this.gcTempTransferCode}" per the instructions above.`
    );
  }

  checkW3wConnectionEnabled() {
    if (this.w3wConnectionEnabled) {
      return true;
    }

    const errorMsg =
      'External Web3 wallet functionality is currently unavailable';

    this.updateSnackbarErrorText(errorMsg);
    this.toggleErrorSnackbar();

    return false;
  }

  createStripeElement() {
    this.stripeElement = this.stripeMixinCreateStripeElement(
      '#stripe-elements-host',
      parseInt((this.subtotal * 10 ** 2).toFixed(0)),
      {
        billingDetails: {
          email: this.user.email,
          phone: this.user.phone,
        },
      },
    );
  }

  @Emit('purchase-complete')
  onBuyComplete(res: { success: boolean; message?: string; results?: any }) {
    this.passcodePrompt = false;
    return res;
  }

  @Watch('transactionFee')
  emitTansactionFee(transactionFee: number) {
    this.$emit('transaction-fee', transactionFee);
  }

  @Watch('selectedCredit')
  handleCreditCardSelection(selectedCredit: FiatProvider) {
    if (selectedCredit === FiatProvider.STRIPE) {
      this.createStripeElement();
    } else if (this.stripeElement) {
      this.stripeMixinDestroyStripeElement(this.stripeElement);
      this.stripeElement = null;
    }
  }
}
